import type ApplicationModel from 'components/framework/ApplicationModel';
import RecordAction from '../RecordAction';

export class OpenInNewTabAction extends RecordAction {
  get title() {
    return 'Open in new tab';
  }

  get icon() {
    return 'fa-regular fa-up-right-from-square';
  }

  showForRecord(record: ApplicationModel): record is ApplicationModel {
    return !!(
      'path' in record &&
      record.path &&
      this.selectedRecords.length === 1
    );
  }

  showForSelectedRecords() {
    if (this.selectedRecords.length !== 1) {
      return false;
    }
    return this.showForRecord(this.selectedRecords[0]);
  }

  async runForRecords(records) {
    window.open(records[0].path, '_blank');
  }
}
